export const MessageStatusType = {
	Unknown: 'Unknown',
	Queued: 'Queued',
	Sent: 'Sent',
	Received: 'Received',
	Error: 'Error',
} as const;
export type MessageStatusType = (typeof MessageStatusType)[keyof typeof MessageStatusType];
